import { mergeAttributes, Node, wrappingInputRule } from '@tiptap/core'

export interface BlockquoteOptions {
  HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    imageLink: {
      /**
       * Set a blockquote node
       */
      setImageLink: () => ReturnType,
      /**
       * Toggle a blockquote node
       */
      toggleImageLink: () => ReturnType,
      /**
       * Unset a blockquote node
       */
      unsetImageLink: () => ReturnType,
    }
  }
}

export const inputRegex = /^\s*>\s$/

export const ImageLink = Node.create<BlockquoteOptions>({

  name: 'imageLink',

  content: 'block+',

  group: 'block',

  defining: true,

  parseHTML() {
    return [
      { tag: 'a' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setImageLink: () => ({ commands }) => {
        return commands.wrapIn(this.name)
      },
      toggleImageLink: () => ({ commands }) => {
        return commands.toggleWrap(this.name)
      },
      unsetImageLink: () => ({ commands }) => {
        return commands.lift(this.name)
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-b': () => this.editor.commands.toggleImageLink(),
    }
  },

  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type,
      }),
    ]
  },
})